import React ,{useState, useEffect} from 'react';
export default function Events(){
    const [curEvents,setCurEvents] = useState([]);
    const [preEvents,setPreEvents] = useState([]);    
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const pUrl = "https://cms.lizakhan.com/items/events?filter[dateTime][_lt]=$NOW";
    const cUrl = "https://cms.lizakhan.com/items/events?filter[dateTime][_gt]=$NOW";

    useEffect(()=>{
	fetch(cUrl).then(res => res.json()).then(result => {
	    setLoading(true);
	    console.log(result.data);
	    setCurEvents(result.data);
	}).catch(error =>{
	    setLoading(true);
	    setError(error);
	})
    }, []);

    useEffect(()=>{
	fetch(pUrl).then(res => res.json()).then(result => {
	    setLoading(true);
	    console.log(result.data);
	    setPreEvents(result.data);
	}).catch(error =>{
	    setLoading(true);
	    setError(error);
	})
    }, []);
    
    if(error){
	return <div> Error: {error}</div>;
    } else if(!loading){
	return <div>Loading ...</div>;
    } else{
	return(<main>
		   <div className="container px-4 py-5">
			   <h1>Current Events</h1>
			   {curEvents &&  curEvents.map(item =>
			       <div class="container my-5">
				   <div class="row p-4 pb-0 pe-lg-0 pt-lg-5 align-items-center rounded-3 border shadow-lg">
				       <div class="col-lg-7 p-3 p-lg-5 pt-lg-3">
					   <h1 class="display-4 fw-bold lh-1">{item.title}</h1>
					   <h4 class="lh-1">{new Date(item.dateTime).toLocaleString('en-MY',{dateStyle:"full", timeStyle:"medium"})}</h4>
					   <p class="lead">{item.about}</p>
					   <div class="d-grid gap-2 d-md-flex justify-content-md-start mb-4 mb-lg-3">
					       <button type="button" class="btn btn-primary btn-lg px-4 me-md-2 fw-bold">Enquire</button>
					       <button type="button" class="btn btn-outline-secondary btn-lg px-4">Become Member</button>
					   </div>
				       </div>
				       <div class="col-lg-4 offset-lg-1 p-0 overflow-hidden shadow-lg">
					   <img class="rounded-lg-3" src={"https://cms.lizakhan.com/assets/"+item.image} alt="" width="720" />
				       </div>
				   </div>
			       </div>
			   )}
		   </div>


		   <div className="container px-4 py-5">
			   <h1>Previous Events</h1>
			   {preEvents &&  preEvents.map(item =>
			       <div class="container my-5">
				   <div class="row p-4 pb-0 pe-lg-0 pt-lg-5 align-items-center rounded-3 border shadow-lg">
				       <div class="col-lg-7 p-3 p-lg-5 pt-lg-3">
					   <h1 class="display-4 fw-bold lh-1">{item.title}</h1>
					   <h4 class="lh-1">{new Date(item.dateTime).toDateString()}</h4>
					   <p class="lead">{item.about}</p>
					   <div class="d-grid gap-2 d-md-flex justify-content-md-start mb-4 mb-lg-3">
					       <button type="button" class="btn btn-primary btn-lg px-4 me-md-2 fw-bold">Newsletter</button>
					       <button type="button" class="btn btn-outline-secondary btn-lg px-4">Become Member</button>
					   </div>
				       </div>
				       <div class="col-lg-4 offset-lg-1 p-0 overflow-hidden shadow-lg">
					   <img class="rounded-lg-3" src={"https://cms.lizakhan.com/assets/"+item.image} alt="" width="720" />
				       </div>
				   </div>
			       </div>
			   )}

		   </div>
	       </main>)
    }
}
